module.exports = __webpack_public_path__ + "static/media/viasat-xtra-5.7051fb9f.png";